<div class="background-color"></div>
<div class="background-template"></div>
<div class="center-content">
  <div class="center-div">
    <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()">
      <div>
        <div class="title-content">Mot de passe oublié, <br /> Saisissez l'adresse mail de votre
          compte.</div>
        <div class="loginSaisieChamps">
          <div class="inputChmp">
            <mat-form-field class="form-group ">
              <input matInput placeholder="Email" required formControlName="emailForgotPassword">
              <mat-error>
                Email requis
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <span>
          <button matButton="filled" class="secondary" [disabled]="!forgetPasswordForm.valid || postWainting">Envoyer<ng-container
              *ngIf="postWainting">...</ng-container></button>
        </span>
        <span style="float: right;">
          <button  routerLink="/login" matButton>Retour</button>
        </span>
      </div>

    </form>
  </div>